<section>
  <app-mini-header></app-mini-header>
  <app-header></app-header>
  <router-view></router-view>
  <app-footer></app-footer>
</section>
